/* general: споделените компоненти, търсенето с ⌘K, заглавията на страниците,
 * формулярът за нов клиент, помощта и „не е намерено“ (2026-09-30).
 * Същата форма като `en/general.ts`. */
export default {
  ui: {
    breadcrumb: 'Навигационна пътека',
    back: 'Назад',
    updated: 'Обновено {when}',
    confirm: {
      title: 'Сигурни ли сте?',
      message: 'Това действие не може да бъде отменено.',
    },
    chips: {
      remove: 'Премахни „{label}“',
    },
    filters: {
      title: 'Филтри',
      close: 'Затвори филтрите',
    },
    bulk: {
      trademark: 'избрана марка | избрани марки',
      case: 'избрано дело | избрани дела',
      client: 'избран клиент | избрани клиента',
      match: 'избрано съвпадение | избрани съвпадения',
      item: 'избран запис | избрани записа',
      selected: 'избрани',
      clear: 'Изчисти избора',
    },
    pagination: {
      showing: 'Показани {range} от {total} {unit}',
      items: 'записа',
      prev: 'Предишна страница',
      next: 'Следваща страница',
    },
    toast: {
      region: 'Съобщения за състоянието',
    },
    error: {
      offlineTitle: 'Изглежда сте офлайн',
      offline: 'Проверете връзката си и опитайте отново.',
      timeoutTitle: 'Времето за изчакване изтече',
      timeout: 'Сървърът не отговори навреме. Опитайте отново след малко.',
      authTitle: 'Сесията ви е изтекла',
      auth: 'Влезте отново, за да продължите — ще се върнете на тази страница.',
      rateTitle: 'Твърде много заявки',
      rate: 'Изчакайте няколко секунди и опитайте отново.',
      serverTitle: 'Сървърът има затруднения',
      generic: 'Възникна неочаквана грешка. Опитайте отново след малко.',
      render: 'Възникна неочаквана грешка при показването на този раздел.',
    },
    notFound: {
      title: {
        item: 'Не е намерено',
        client: 'Клиентът не е намерен',
        trademark: 'Марката не е намерена',
        report: 'Отчетът не е намерен',
        case: 'Делото по опозиция не е намерено',
      },
      sub: 'Възможно е да е изтрито, връзката да е остаряла или профилът ви да няма достъп до него.',
    },
  },

  search: {
    label: 'Търсене в Lexentiqa',
    placeholder: 'Търсене на марки, клиенти и дела…',
    hint: 'Въведете поне две букви, за да търсите марки, клиенти и дела по опозиция.',
    searching: 'Търсене…',
    noResults: 'Няма резултати за „{q}“. Опитайте с име на марка, клиент или номер на дело.',
    failed: 'Търсенето в момента не е достъпно. Опитайте отново след малко.',
    navigate: 'придвижване',
    open: 'отваряне',
    close: 'затваряне',
    anywhere: 'от всяка страница',
  },

  route: {
    dashboard: 'Табло',
    monitoring: 'Наблюдение на марки',
    matchDetail: 'Преглед на съвпадение',
    trademarks: 'Моите марки',
    trademarkNew: 'Добавяне на марка',
    trademarkDetail: 'Досие на марка',
    oppositions: 'Дела по опозиция',
    oppositionNew: 'Ново дело по опозиция',
    oppositionDetail: 'Дело по опозиция',
    reports: 'Справки',
    reportDetail: 'Отчет от сканиране',
    clients: 'Клиенти',
    clientNew: 'Добавяне на клиент',
    clientDetail: 'Клиент',
    people: 'Хора',
    personNew: 'Нов човек',
    person: 'Профил на човек',
    clientEdit: 'Редактиране на клиент',
    notifications: 'Известия',
    help: 'Помощен център',
    howItWorks: 'Как работи наблюдението',
    roadmap: 'Какво изграждаме',
    account: 'Профил',
    settings: 'Настройки',
    styleguide: 'Стилово ръководство',
    signIn: 'Вход',
    forgotPassword: 'Възстановяване на паролата',
    setPassword: 'Задаване на парола',
    notFound: 'Не е намерено',
  },

  addClient: {
    subtitle:
      'Добавете нов притежател на марки в работната среда. Наблюдението се настройва за всяка марка поотделно, след като марките му бъдат добавени.',
    create: 'Създай клиент',
    creating: 'Създаване…',
    workspace: 'Добавяне на клиент',
    required: 'Задължително',
    company: {
      title: 'Данни за дружеството',
      sub: 'Юридическото лице, на което принадлежат марките.',
      name: 'Наименование',
      namePlaceholder: 'напр. „Пример“ ЕООД',
      nameHint: 'Пълното наименование, както е вписано в Търговския регистър.',
      nameRequired: 'Въведете наименованието на клиента.',
      nameShort: 'Наименованието трябва да е поне {n} знака.',
      tradingName: 'Търговско наименование',
      tradingNamePlaceholder: 'Ако се различава от наименованието',
      legalForm: 'Правна форма',
      legalFormPlaceholder: 'Изберете правна форма…',
      registrationNumber: 'Регистрационен номер',
      registrationNumberPlaceholder: 'ЕИК / фирмен №',
      founded: 'Година на основаване',
      foundedPlaceholder: 'ГГГГ',
      industry: 'Отрасъл',
      industryPlaceholder: 'Изберете отрасъл…',
      size: 'Размер на дружеството',
      sizePlaceholder: 'Изберете размер…',
      website: 'Уебсайт',
    },
    legalForm: {
      ood: 'ООД',
      eood: 'ЕООД',
      ad: 'АД',
      ead: 'ЕАД',
      et: 'ЕТ',
      gmbh: 'GmbH (Германия, Австрия)',
      sa: 'S.A. / SARL (Франция и др.)',
      inc: 'Inc. / Corp. (САЩ)',
      llc: 'LLC (САЩ)',
      other: 'Друга',
    },
    industry: {
      software: 'Софтуер и SaaS',
      finance: 'Финансови услуги',
      manufacturing: 'Промишлено производство',
      cosmetics: 'Козметика и красота',
      pharma: 'Фармация и медицина',
      biotech: 'Биотехнологии',
      beverages: 'Напитки',
      fashion: 'Мода и облекло',
      telecom: 'Телекомуникации',
      other: 'Друго',
    },
    size: {
      s1: '1–10 служители',
      s2: '11–50 служители',
      s3: '51–200 служители',
      s4: '201–500 служители',
      s5: '501–1000 служители',
      s6: 'над 1000 служители',
    },
    hq: {
      title: 'Седалище',
      sub: 'Къде е регистрирано самото дружество. Регистрите, в които се наблюдават марките му, се избират за всяка марка, а не тук.',
      country: 'Държава / регион',
      countryPlaceholder: 'Изберете държава…',
    },
    contact: {
      title: 'Лице за контакт',
      sub: 'С кого да се свързвате в дружеството клиент. Съхранява се в записа на клиента.',
      name: 'Име на лицето за контакт',
      namePlaceholder: 'Име и фамилия',
      nameRequired: 'Въведете името на лицето за контакт.',
      email: 'Имейл',
      emailRequired: 'Въведете имейл адреса на лицето за контакт.',
      emailInvalid: 'Въведете валиден имейл адрес.',
    },
    notes: {
      title: 'Вътрешни бележки',
      sub: 'Контекст за вашия екип. Никога не се показва на клиента.',
      label: 'Бележки',
      placeholder:
        'Как започна връзката, кой ви препоръча, всичко, което следващият колега, поел клиента, трябва да знае.',
    },
    rail: {
      label: 'Помощ при добавянето',
      checklist: 'Стъпки при добавяне на клиент',
      step: 'Стъпка {n}.',
      step1: 'Попълнете данните за дружеството и седалището.',
      step2: 'Посочете лицето за контакт в дружеството клиент.',
      step3:
        'След като създадете клиента, добавете марките му — всяка марка има собствен обхват на наблюдение.',
      done: 'Готово',
    },
    actions: 'Действия с формуляра',
    notSaved: 'Нищо не се запазва, преди да създадете клиента.',
    incomplete: 'Попълнете задължителните полета',
    created: 'Клиентът е създаден',
    createdSub: '{name} е добавен към списъка ви с клиенти.',
    failed: 'Клиентът не беше създаден',
  },

  help: {
    title: 'Помощен център',
    subtitle:
      'Как работи продуктът, къде да намерите нужното и кратки отговори на честите въпроси.',
    topics: 'Теми за помощ',
    topic: {
      howItWorks: 'Как работи наблюдението',
      howItWorksSub: 'От бюлетина на регистъра до конфликт на бюрото ви, стъпка по стъпка',
      roadmap: 'Какво изграждаме и докъде сме стигнали',
      roadmapSub:
        'Целият план на разработката на разбираем език — завършено, в процес и предстоящо',
      trademarksSub:
        'Марките на клиентите ви, регистрите, в които се наблюдава всяка от тях, и документите им',
      monitoringSub:
        'Какво откри наблюдението срещу марките на клиентите ви и как е решена всяка двойка',
    },
    faq: {
      title: 'Често задавани въпроси',
      sub: 'Кратки отговори за това как работи продуктът днес.',
      bulletins: {
        q: 'Колко често се събират новите бюлетини?',
        a: 'Платформата проверява за нови бюлетини на EUIPO и WIPO на всеки три часа и прочита всеки от тях, след като бъде изтеглен. Националните регистри, включително Патентното ведомство на България, все още не се четат. Сравняването на новите заявки с вашите марки е отделна стъпка — сканиране, което се пуска от оператора на платформата; за всеки ден, в който е имало сканиране, има отделен отчет в „Справки“.',
      },
      sensitivity: {
        q: 'Можем ли да променим чувствителността на съпоставянето?',
        a: 'Не за отделна кантора. Съпоставянето се настройва за цялата платформа от нейния оператор спрямо цел за обхват: делът от двойките марки, по които действително е подадена опозиция пред EUIPO, които системата трябва да представи на юрист, измерен върху собствените записи на EUIPO за опозиции. При всяко съвпадение е посочено как е решено — чрез правило за съвпадение или след прочит от AI съдията, заедно с мотивите му.',
      },
      clientAccess: {
        q: 'Може ли клиентът да има собствен достъп само за четене?',
        a: 'Да. Клиентският профил е само за четене. Той вижда единствено откритите дела по опозиция за собствените си марки, а в тях — само стъпките, бележките и документите, които кантората е отбелязала като видими за клиента, както и законовите срокове. Наблюдението и съвпаденията не са видими за него. Добавянето на хора и изборът какво вижда всеки от тях все още не са в приложението: обърнете се към оператора на платформата.',
      },
      deadlines: {
        q: 'Откъде идват сроковете по делата?',
        a: 'Дело, открито от съвпадение, започва със срока за опозиция на намерената заявка, взет от публикацията на регистъра. Когато правилото зад тази дата още не е потвърдено от юристите на кантората — всяка дата от WIPO и повторните публикации на международни регистрации в EUIPO, — срокът е отбелязан като предварителен: проверете го, преди да разчитате на него. Всички останали срокове се добавят от юрист на страницата на делото. Отговорният юрист (или основният профил на кантората, ако няма отговорник) получава напомняне седмица преди срока, ден преди него, в самия ден и след като е изтекъл — в приложението, а по имейл, когато платформата изпраща имейли и той не ги е изключил в „Настройки“.',
      },
      data: {
        q: 'Къде се съхраняват данните ни?',
        a: 'Базата данни и всички качени файлове се съхраняват на собствения сървър на платформата, в център за данни в Германия, в рамките на ЕС — а не в облачна услуга за съхранение. Базата данни се копира всяка нощ и всяко копие се пази до 30 дни; освен това се архивира целият диск на сървъра. Работата с изкуствен интелект се извършва на наш собствен графичен хардуер в България: той получава марките за сравнение и връща отговора си. Когато труден случай се предаде на платения AI модел (Claude на Anthropic), той получава двете сравнявани марки — имената им, стоките и услугите и писмено описание на логото, ако има такова — без имена на клиенти и без файлове.',
      },
      search: {
        q: 'Как да намеря бързо марка, клиент или дело?',
        a: 'Натиснете ⌘K (Ctrl+K в Windows) на която и да е страница или щракнете в полето за търсене горе и въведете поне две букви от марка, клиент, заглавие или номер на дело.',
      },
    },
  },

  notFound: {
    sub: 'Страницата, която търсите, не съществува или е преместена.',
    back: 'Обратно към работната среда',
  },
} as const
